/* On Paper — subscribe email echo.
   Capture-phase submit listener runs before Ghost Portal handles the event,
   reads the email value, and writes it into the success panel's slot. Plain
   textContent — no HTML interpolation. Safe to no-op if the slot is missing
   (older form variants) or input is empty. */
(function () {
  function bind(form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('[data-members-email]');
      var slot  = form.querySelector('[data-op-subscribe-email]');
      if (input && slot && input.value) slot.textContent = input.value;
    }, { capture: true });
  }
  document.querySelectorAll(
    '.op-coming-soon__form, .op-subscribe__form, .op-sub-form'
  ).forEach(bind);
})();
